"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsUndefined_1 = __importDefault(require("../typeAssertions/valueIsUndefined"));
const shallowCompare = (object1) => (object2) => {
    const entries1 = Object.entries(object1);
    const entries2 = Object.entries(object2);
    if (entries1.length !== entries2.length) {
        return false;
    }
    const notMatchet = entries1.find(([propName, propValue1]) => {
        const propValue2 = object2[propName];
        return propValue1 !== propValue2;
    });
    return (0, valueIsUndefined_1.default)(notMatchet);
};
exports.default = shallowCompare;
